import { Link } from "react-router-dom";
import business from "../data/business.json";
import { Wave } from "./Wave";
import { Ph } from "../lib/draft";

export const Footer = ({ onCookiePrefs }) => (
    <footer className="bg-carbone border-t border-bordo">
        <div className="container-pub pt-14 pb-10">
            <div className="grid gap-10 md:grid-cols-4">
                <div>
                <div className="flex items-center gap-3">
                    <img
                        src="/images/logo-river-pub.png"
                        alt="Logo River Pub"
                        width={44}
                        height={44}
                        className="h-11 w-11 rounded-full"
                    />
                    <span className="flex flex-col items-start leading-none">
                        <span className="font-heading font-semibold uppercase text-xl tracking-[0.22em]">
                            River Pub
                        </span>
                        <Wave className="w-12 h-2.5 mt-1.5 text-ambra" />
                    </span>
                </div>
                    <p className="mt-4 text-sm text-avorio/70">{business.legalName}</p>
                    <p className="mt-5 text-xs leading-relaxed border border-ambra/30 bg-superficie rounded-lg p-3 text-avorio/80">
                        Vietata la vendita e la somministrazione di bevande alcoliche ai minori di 18 anni. Bevi
                        responsabilmente.
                    </p>
                </div>
                <div>
                    <h3 className="font-heading uppercase tracking-wide text-lg">Contatti</h3>
                    <ul className="mt-3 space-y-2 text-sm text-avorio/80">
                        <li>
                            {business.address.street}, {business.address.zip} {business.address.city} (
                            {business.address.province})
                        </li>
                        <li>
                            <a className="tabular hover:text-ambra" href={business.phone.href} data-testid="footer-phone-link">
                                {business.phone.display}
                            </a>
                        </li>
                        <li>
                            <a href={`mailto:${business.pec}`} data-testid="footer-pec-link">
                                PEC: {business.pec}
                            </a>
                        </li>
                    </ul>
                </div>
                <div>
                    <h3 className="font-heading uppercase tracking-wide text-lg">Orari</h3>
                    <ul className="mt-3 space-y-2 text-sm text-avorio/80 tabular">
                        <li>Lun – Gio · 21:00 – 02:00</li>
                        <li>Ven – Sab · 21:00 – 03:00</li>
                        <li>Domenica · Chiuso</li>
                    </ul>
                </div>
                <div>
                    <h3 className="font-heading uppercase tracking-wide text-lg">Link</h3>
                    <ul className="mt-3 space-y-2 text-sm text-avorio/80">
                        <li>
                            <a className="hover:text-ambra" href="#locale">
                                Il locale
                            </a>
                        </li>
                        <li>
                            <a className="hover:text-ambra" href="#menu">
                                Menu
                            </a>
                        </li>
                        <li>
                            <a className="hover:text-ambra" href="#recensioni">
                                Recensioni
                            </a>
                        </li>
                        <li>
                            {business.facebook ? (
                                <a
                                    className="hover:text-ambra"
                                    href={business.facebook}
                                    target="_blank"
                                    rel="noreferrer"
                                    data-testid="footer-facebook-link"
                                >
                                    Facebook
                                </a>
                            ) : (
                                <span>
                                    Facebook: <Ph what="URL della pagina Facebook" />
                                </span>
                            )}
                        </li>
                        {business.instagram && (
                            <li>
                                <a
                                    className="hover:text-ambra"
                                    href={business.instagram}
                                    target="_blank"
                                    rel="noreferrer"
                                    data-testid="footer-instagram-link"
                                >
                                    Instagram
                                </a>
                            </li>
                        )}
                        <li>
                            <Link className="hover:text-ambra" to="/privacy" data-testid="footer-privacy-link">
                                Privacy policy
                            </Link>
                        </li>
                        <li>
                            <Link className="hover:text-ambra" to="/cookie" data-testid="footer-cookie-link">
                                Cookie policy
                            </Link>
                        </li>
                        <li>
                            <button
                                className="underline hover:text-ambra"
                                onClick={onCookiePrefs}
                                data-testid="footer-cookie-prefs"
                            >
                                Preferenze cookie
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="mt-12 pt-6 border-t border-bordo/60 flex flex-wrap gap-x-6 gap-y-2 justify-between text-xs text-avorio/60">
                <span data-testid="footer-copyright">
                    © {new Date().getFullYear()} {business.legalName} · P.IVA{" "}
                    {business.vat || <Ph what="partita IVA" />}
                </span>
                <span>Valutazioni e recensioni: Google</span>
            </div>
        </div>
    </footer>
);